<style lang="scss" scoped>
@use "assets/scss/components/input.scss";
@use "@/assets/scss/variables.scss" as variables;

.cancel {
  position: absolute;
  right: 8px;
  top: calc(50% - 12px);
  color: variables.$red;
  cursor: pointer !important;
  opacity: 1 !important;
  transition: all 0.2s ease;
}
.tooltip {
  position: absolute;
  right: 8px;
  top: calc(50% - 12px);
  cursor: pointer !important;
  opacity: 1 !important;
  transition: all 0.2s ease;
}
</style>

<template>
  <div v-auto-animate :class="{
		'required': validation.includes('required'),
		'disabled': disable,
		'error': displayErrors.length > 0,
		'isFocus': isFocus,
	}" class="cinput" @click="focusInput">

    <div v-if="type !== 'file'" class="content">
      <input ref="input" v-model="current" :class="{
					   'error': displayErrors.length > 0,
					   'uppercase': upperCase,
			       }"
             :data-form-type="dataFormType" :disabled="disable"
             :min="type === 'number' ? 1 : ''"
             :name="id" :placeholder="placeholder ?? label" :type="type"
             class="content__field"
             @focusin="isFocus = true"
             @focusout="isFocus = false"
             @input="this.$emit('update:current', $event.target.value)">
      <label :for="id" class="content__label">{{ label || "Label non défini" }}</label>
      <i v-if="disable && canCancel" class="isax isax-close-circle cancel" @click="handleCancel"></i>
      <div v-if="tooltip" class="tooltip">
        <UTooltip :content="{ side: 'top' }" :text="tooltip">
          <i class="isax isax-info-circle"></i>
        </UTooltip>
      </div>
    </div>


    <!-- Input type file -->
    <div v-else :class="displayErrors.length > 0 ? 'error' : ''" class="content">
      <input :id="id" :accept="accept" :disabled="disable" :hidden="hidden && preview" :name="id" ref="input"
             :placeholder="placeholder ?? label" :type="type" class="content__field" @change="handleFileChange" :multiple="multipleFiles"
             @input="checkInput">
      <label :for="id" class="content__label">{{ label }}
        <span>{{ modelValue.size ? bytesToSize(modelValue.size) : bytesToSize(0) }} / {{
            bytesToSize(maxSize)
          }}</span></label>
      <i v-if="modelValue.base64 && !preview" class="isax isax-close-circle cancel" @click="handleCancel"></i>
      <div class="content__placeholder" @click="handleClick">
        <img v-if="preview && modelValue.base64"
             :src="modelValue.base64 ?? ''">
      </div>
    </div>
    <!-- Show only first error -->
    <div v-if="displayErrors.length > 0 && !disable" class="cinput__error">
      {{ displayErrors[0] }}
    </div>
  </div>
</template>
<script>

import { defineExpose } from "vue";

export default {
  name: "c-input",
  props: {
    id: {
      type: String,
      required: false
    },
    label: {
      type: String,
      default: ""
    },
    dataFormType: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    upperCase: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String
    },
    preview: {
      type: Boolean,
      default: true
    },
    maxSize: {
      type: Number,
      // 16 MB
      default: 16777216
    },
    validation: {
      type: String,
      default: ""
    },
    accept: {
      type: String,
      default: ""
    },
    canCancel: {
      type: Boolean,
      default: false
    },
    hidden: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "text"
    },
    multipleFiles: {
      type: Boolean,
      default: false
    },
    modelValue: { // String or number
      type: [String, Number, Object],
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    },
    // External error (e.g. server validation). Shown in addition to the
    // client validation and cleared automatically as soon as the user
    // edits the field (emits `update:error`).
    error: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      errors: [],
      backgroundImage: null,
      isFocus: false,
      current: this.modelValue,
      // True during a downward parent -> child sync, so the value is not
      // re-emitted to the parent in a loop.
      syncingFromParent: false
    };
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    },
    // Displayed errors = client validation + external (server) error
    displayErrors() {
      return this.error ? [...this.errors, this.error] : this.errors;
    }
  },
  methods: {
    handleCancel() {
      this.$emit("update:modelValue", "");
      this.backgroundImage = null;
      this.$el.querySelector("input").value = "";
    },
    focusInput() {
      this.$el.querySelector("input").focus();
    },
    handleFileChange() {
      console.log(this.$refs)
      const input = this.$refs.input;
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        this.backgroundImage = e.target.result;
        this.$emit("update:modelValue", {
          name: file.name,
          size: file.size,
          type: file.type,
          base64: e.target.result,
          lastModified: file.lastModified,
          lastModifiedDate: file.lastModifiedDate
        });
      };
      reader.readAsDataURL(file);
      if (file.size > this.maxSize) {
        this.errors.push(this.$t("form.errors.fileTooLarge"));
        input.classList.add("error");
      } else {
        input.classList.remove("error");
      }
    },
    handleClick() {
      const input = this.$el.querySelector("input");
      input.click();
    },
    getType() {
      return "input";
    },
    checkInput(silence = false) {
      const input = this.$refs.input;
      const value = this.current;
      if (this.validation.length === 0) return true;
      else if (!this.validation.includes("required") && (!value || value?.length === 0)) return true;
      const validation = this.validation.split("|");
      // Each rule's message in the person's language (lang/*.json, form.errors); `min` and `max` name their length.
      const message = (name, params) => this.$t(`form.errors.${ name }`, { min: params, max: params });
      if (!silence) this.errors = [];
      let pass = true;
      validation.forEach((rule) => {
        let [name, ...params] = rule.split(":");
        params = params.join(":");
        const isValid = this[name](value, params);
        if (!isValid) {
          if (!silence) this.errors.push(message(name, params));
          pass = false;
        }
      });
      if (this.validation.length > 0 && (silence && !pass)) {
        input?.classList.add("error");
      } else {
        input?.classList.remove("error");
      }
      return silence ? pass : this.errors.length === 0;
    },
    required(value) {
      return value !== "";
    },
    min(value, min) {
      return value.length >= min;
    },
    url(value) {
      return new RegExp(/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/).test(value);
    },
    max(value, max) {
      return value.length <= max;
    },
    length(value, min, max) {
      return value.length >= min && value.length <= max;
    },
    matches(value, regex) {
      return new RegExp(regex).test(value);
    },
    email(value) {
      return new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/).test(value);
    },
    same(value, idValue2) {
      return document.getElementById(idValue2) ? value === document.getElementById(idValue2).value : true;
    },
    phone(value) {
      return new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/).test(value);
    }
  },
  watch: {
    // `modelValue` -> `current` -> emit `update:modelValue` -> `modelValue`...
    // The cycle only stopped if the parent sent back exactly the same
    // value. As soon as it transformed it (or for a non-primitive value), we
    // went into infinite recursion: "Maximum call stack size exceeded".
    // The guard breaks the loop at its source.
    modelValue(newVal) {
      if (newVal === this.current) return;
      this.syncingFromParent = true;
      this.current = newVal;
    },
    current(newVal) {
      this.checkInput();
      // As soon as the user edits the field, the server error is cleared
      if (this.error) this.$emit("update:error", "");
      if (this.syncingFromParent) {
        this.syncingFromParent = false;
        return;
      }
      if (newVal !== this.modelValue) this.$emit("update:modelValue", newVal);
    },
    isFocus(val) {
      if (!val) {
        this.checkInput();
      } else {
        // A c-input is not always a child of a c-select: only touch the
        // parent if it does expose a dropdown.
        if (this.$parent && "showDropdown" in this.$parent && !this.$parent.showDropdown) {
          this.$parent.showDropdown = true;
        }
      }
    }
  },
  mounted() {
    defineExpose({
      checkInput: this.checkInput
    });
  }
};
</script>
